import { Navigate, useLocation } from 'react-router-dom';
import ConstructorDetail from 'src/content/applications/Contractors/ConstructorDetail';
import { useAdminWorkspace } from './AdminWorkspaceProvider';

export default function LegacyWorkerDetailAdapter() {
  const state = useAdminWorkspace();
  const location = useLocation();
  if (state.kind === 'company') {
    if (state.status !== 'ready') return null;
    const id = (location.state as { user?: { id?: unknown } } | null)?.user?.id;
    const valid = typeof id === 'number' && Number.isSafeInteger(id) && id > 0;
    return (
      <Navigate
        replace
        to={`${state.workspace.routeBase}/workers${valid ? `/${id}` : ''}`}
      />
    );
  }
  if (state.kind === 'platform')
    return <Navigate replace to="/platform/workforce" />;
  if (state.kind !== 'legacy') return <Navigate replace to="/login" />;
  return <ConstructorDetail />;
}
